module.exports = __webpack_public_path__ + "static/media/hero-banner-xl.9921e666.jpg";